export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_DEFAULT_1.d621f839.jpg";